import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { ArrowRight } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { Loader } from "@domestika-dev/prudencio/dist/atoms/Loader/Loader";
import When from "../../../../common/When";

export const SetupInstructions = ({
  liveChannelLoading,
  onFirstInstructionClick,
  onSecondInstructionClick,
}) => {
  const getInstructionContent = ({ title, body, button, onClick, liveChannelLoader }) => (
    <Grid gridRowGap={[2, 2, 2]}>
      <GridItem gridRow={1} gridColumn="1 / span 8">
        <Text as="h3" size="tiny" fontWeight="medium">
          <FormattedMessage id={title} />
        </Text>
      </GridItem>
      <GridItem gridRow={2} gridColumn="1 / span 8">
        <Text size="micro">
          <FormattedMessage id={body} />
        </Text>
      </GridItem>
      <GridItem gridRow={3} gridColumn="1 / span 8">
        <Button buttonType="text" size="none" disabled={liveChannelLoading} action={onClick}>
          <Text color="rambutan" size="micro" fontWeight="medium">
            <FormattedMessage id={button} />
          </Text>
          <When condition={liveChannelLoading && liveChannelLoader}>
            {() => <Loader marginLeft={1} color="rambutan" />}
          </When>
          <When condition={!liveChannelLoader || !liveChannelLoading}>
            {() => (
              <IconForm marginLeft={1} color="rambutan">
                <ArrowRight />
              </IconForm>
            )}
          </When>
        </Button>
      </GridItem>
    </Grid>
  );

  return (
    <Grid gridRowGap={[5, 5, 5]} marginBottom={8}>
      <GridItem gridRow={1} gridColumn="1 / span 8">
        <Text size="medium" fontWeight="medium" as="h2" textAlign="left">
          <FormattedMessage id="live_sessions.setup_instructions.title" />
        </Text>
      </GridItem>
      <GridItem gridRow={2} gridColumn="1 / span 8">
        {getInstructionContent({
          title: "live_sessions.setup_instructions.configure_computer.title",
          body: "live_sessions.setup_instructions.configure_computer.body",
          button: "live_sessions.setup_instructions.configure_computer.button",
          onClick: onFirstInstructionClick,
          liveChannelLoader: true,
        })}
      </GridItem>
      <GridItem gridRow={3} gridColumn="1 / span 8">
        {getInstructionContent({
          title: "live_sessions.setup_instructions.start_session.title",
          body: "live_sessions.setup_instructions.start_session.body",
          button: "live_sessions.setup_instructions.start_session.button",
          onClick: onSecondInstructionClick,
        })}
      </GridItem>
    </Grid>
  );
};

SetupInstructions.propTypes = {
  liveChannelLoading: PropTypes.bool,
  onFirstInstructionClick: PropTypes.func.isRequired,
  onSecondInstructionClick: PropTypes.func.isRequired,
};

SetupInstructions.defaultProps = {
  liveChannelLoading: false,
};

export default SetupInstructions;
